import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {loadInterestInvestor as load, submitInterestInvestor as submit} from 'flows/interest/investor/index';

import InterestInvestor from './component';

export class InterestInvestorContainer extends React.Component {
  componentDidMount() {
    this.props.load();
  }
  render() {
    return <InterestInvestor submit={this.props.submit} />
  }
}

InterestInvestorContainer.propTypes = {
  load: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};

export default connect(null, {load, submit})(InterestInvestorContainer);



// WEBPACK FOOTER //
// ./web/flows/interest/investor/index.js